import React, { useEffect } from "react";
import {Box, HStack, Spacer, Text, 
      Flex, IconButton, 
      useColorModeValue, Image,
      VStack, ButtonGroup, Button, Link , Heading } from "@chakra-ui/react";
import { ArrowLeftIcon } from "@chakra-ui/icons";
import { isAndroid, isIOS } from "react-device-detect";
import { useNavigate } from 'react-router-dom';
// import AppLink from 'react-native-app-link';
import NextLink from 'next/link'
import { MdArrowBackIosNew } from 'react-icons/md';

var userAgent = "";

function MordeeDeepLink() {
    const navigate = useNavigate();
    const textColor = useColorModeValue("#565E6D");
    useEffect(() => {
        // const url = "https://truehealth.truedigital.com/mordeeapp-livingtech";
        // // AppLink.maybeOpenURL(url).then(() => {
        // //     // do stuff
        // //   })
        // //   .catch((err) => {
        // //     // handle errorhttp://onelink.to/yja659
        // //   });
        // if (isAndroid) {
        //      //window.location.replace(url);
        //      //window.location.assign(url)
        //      userAgent = "Android";
        //      openApp("com.truedigital.vhealth")
        //         .then(
                    
        //             console.log("Successfully navigated")
        //         )
        //         .catch(
        //             console.warn("Failed ")
        //         );
        // } else if (isIOS) {
        //     //window.location.replace(url);
        //     window.location.assign(url)
        //     userAgent = "iOS";

        //     setTimeout(() => {
        //         window.location.replace(
        //         "https://truehealth.truedigital.com/mordeeapp-livingtech"
        //         );
        //     }, 1000);
        // } else {
        //     userAgent = "Web";
        //     window.location.assign(url)
        //     //window.location.replace("https://truehealth.truedigital.com/mordeeapp-livingtech");
        // }
    }, []);

    return (
    <div>
        <Box w='100%' px={4}>
              <Flex h={14} alignItems={'center'} justifyContent={'center'}>
                    {/*<IconButton
                        size={'lg'}
                        icon={<MdArrowBackIosNew color="black"/>}
                        colorScheme='white'
                        aria-label={'Back'}
                        display={{ md: 'none' }}
                        onClick={() => navigate(-1)}
                    />*/}
                    <Heading color={textColor} fontSize='20px' fontWeight='700' textAlign='center'>Health</Heading>
                    {/*<Heading color={textColor} fontSize='20px' fontWeight='700' textAlign='center' ml={'50px'}></Heading>*/}
                {/*<HStack spacing={8} alignItems={'center'}>
                    <Box alignItems={'center'}>Health</Box>
                    <HStack
                    as={'nav'}
                    spacing={4}
                    display={{ base: 'none', md: 'flex' }}>
                    </HStack>
                </HStack>*/}
                {/*<Flex alignItems={'center'}><Spacer/></Flex>*/}
                </Flex>
            </Box>
        <VStack spacing={10} align='stretch'>
            <Flex h='10' width="100%">
                <Text>{userAgent}</Text>
            </Flex>
        </VStack>
        

        {isAndroid ? (
        <Flex alignItems={'center'} justifyContent={'space-between'} flexDirection='column' gap={'24px'} padding={'10px'}>
          <Image className="d-block w-100" src="/banner/Mordeeandroid.png" alt="Mordeeandroid" />
          <NextLink href='https://mordee.app.link/JwFvHF0HZub' passHref>
            <a>
            <Image src="/icon/OpenAppMordee.png" alt="OpenAppMordee" />
            </a>
            
          </NextLink>
          <Text textAlign={'center'} color={'#565E6D'} fontSize='12pt'>If you don’t have Mordee Apps, You can download app in App Store. After that you can create an account and connect your doctor in the application</Text>
          <NextLink href="https://mordee.app.link/JwFvHF0HZub" passHref>
            <a>
            <Image src="/icon/googleplay.png" width='190' alt="googleplay"></Image>
            </a>
            
          </NextLink>
          
        </Flex>
      ) : isIOS ? (
        <Flex alignItems={'center'} justifyContent={'space-between'} flexDirection='column' gap={'24px'} padding={'10px'}>
          <Image className="d-block w-100" src="/banner/Mordeeios.png"  alt="Mordeeios"/>
          <NextLink href='fb1023049748126379://' passHref>
          <a>
          <Image src="/icon/OpenAppMordee.png" alt="OpenAppMordee" />
          </a>
            
          </NextLink>
          <Text textAlign={'center'} color={'#565E6D'} fontSize='12pt'>If you don’t have Mordee Apps, You can download app in App Store. After that you can create an account and connect your doctor in the application</Text>
          <NextLink href='https://apps.apple.com/th/app/mordee/id1533061864' passHref>
            <a>
            <Image src="/icon/AppStore.png" width='190' alt="AppStore" />
            </a>
            
          </NextLink>
        </Flex>
        
      ) : (
        <Flex alignItems={'center'} justifyContent={'space-between'} flexDirection='column' gap={'24px'} padding={'10px'}>
          <Image className="d-block w-100" src="/banner/Mordeeios.png" alt="Mordeeios" />
          <NextLink href='fb1023049748126379://' passHref>
            <a>
              <Image src="/icon/OpenAppMordee.png"  alt="OpenAppMordee"/>
            </a>
            
          </NextLink>
          <Text textAlign={'center'} color={'#565E6D'} fontSize='12pt'>If you don’t have Mordee Apps, You can download app in App Store. After that you can create an account and connect your doctor in the application</Text>
          <NextLink href='https://apps.apple.com/th/app/mordee/id1533061864' passHref>
          <a>
          <Image src="/icon/AppStore.png" width='190' alt="AppStore"/>
          </a>
          </NextLink>
        </Flex>
      )}
    </div>
  );
};

export default MordeeDeepLink;